var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.696,
    height: 21.265,
    viewBox: "0 0 23.696 21.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_423",
    "data-name": "Groupe 423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_463",
    "data-name": "Trac\\xE9 463",
    d: "M-22.966,158.25a.912.912,0,0,0-.911.911v3.646a1.521,1.521,0,0,1-1.519,1.519H-42.408a1.521,1.521,0,0,1-1.519-1.519v-3.646a.912.912,0,0,0-.911-.911.912.912,0,0,0-.911.911v3.646a3.344,3.344,0,0,0,3.342,3.342H-25.4a3.344,3.344,0,0,0,3.342-3.342v-3.646A.912.912,0,0,0-22.966,158.25Z",
    transform: "translate(45.75 -144.883)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_464",
    "data-name": "Trac\\xE9 464",
    d: "M-35.622,163.387a.9.9,0,0,0,.644.267.9.9,0,0,0,.644-.267l4.861-4.861a.91.91,0,0,0,0-1.288.91.91,0,0,0-1.288,0l-3.305,3.3V148.161a.912.912,0,0,0-.911-.911.912.912,0,0,0-.911.911v12.381l-3.305-3.3a.91.91,0,0,0-1.288,0,.91.91,0,0,0,0,1.288Z",
    transform: "translate(46.826 -147.25)",
    fill: "#161615"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a8581bccc7ff18b86a3b25b0e4ce3ae4.svg";
export { ForwardRef as ReactComponent };